import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container } from 'styles/layout';
import { IWithThemeProps } from 'typings';

interface INotificationPreferenceContainerProps {
  isEmailChecked: boolean;
  isUnavailable: boolean;
}

interface IEmailContainerProps {
  isEmailChecked: boolean;
}

export const Container = styled.div`
  ${container}

  margin-top: 16px;
`;

export const NotificationPreferenceContainer = styled.div<INotificationPreferenceContainerProps>`
  ${({ theme }: IWithThemeProps) => `
    transition: opacity ${theme.transitionDurationCarouselTrack} ease,
      margin-top ${theme.transitionDurationCarouselTrack} ease;
  `}

  ${({ isEmailChecked, isUnavailable }) => {
    if (!isUnavailable) {
      return `
        opacity: 1;
        margin-top: 0;
      `;
    } else if (isEmailChecked) {
      return `
        opacity: 0;
        margin-top: -143px;
      `;
    } else {
      return `
        opacity: 0;
        margin-top: -81px;
      `;
    }
  }}
`;

export const PillContainer = styled.div`
  position: relative;
  z-index: 2;

  ${({ theme }: IWithThemeProps) => `
    background: ${theme.bottomBackgroundColor};
  `}
`;

export const EmailContainer = styled.div<IEmailContainerProps>`
  margin: -43px auto -12px;
  opacity: 0;
  overflow: hidden;
  padding-right: 6px;
  transition-property: margin-top, opacity;
  transition-timing-function: ease;

  ${({ theme }: IWithThemeProps) => `
    transition-duration: ${theme.transitionDurationCarouselTrack};
  `}

  ${large`
    padding-right: 0;
    width: 360px;
  `}

  ${({ isEmailChecked }) => {
    if (isEmailChecked) {
      return `
        margin-top: 16px;
        opacity: 1;
      `;
    }

    return '';
  }}
`;
